import React, { useState, useEffect, useRef } from 'react';
import './header.scss';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../../helper.scss';
import { convertToUpperCase } from '../../Utils/ToUpperCase/to-upper-case.tsx';
import anytrakkLogo from '../../../assets/anytrakk.png';
import notifySound from '../../../assets/notification.mp3';

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000; 

const Header = () => {
  const [isOpen, toggleOpen] = useState(false);
  const menuClass = `dropdown-menu${isOpen ? " show" : ""}`;
  
  const [isBellOpen, setBellOpen] = useState(false);
  const [notifications, setNotifications] = useState(() => {
    const savedNotifs = localStorage.getItem('user_notifications');
    if (savedNotifs) {
      const parsed = JSON.parse(savedNotifs);
      const cutoffTime = Date.now() - SEVEN_DAYS_MS;
      return parsed.filter((n: any) => n.id > cutoffTime); 
    }
    return [];
  });
  
  const [unreadCount, setUnreadCount] = useState(0); 
  const [isAnimating, setIsAnimating] = useState(false);
  const bellMenuClass = `dropdown-menu${isBellOpen ? " show" : ""}`;
  const storedUserDetails = localStorage.getItem("userdetails");
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  const userName = userDetails ? userDetails.user.name.replace(/^"(.*)"$/, '$1') : null;
  const userRole = convertToUpperCase(userDetails ? userDetails.role : null);
  const bellRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (bellRef.current && !bellRef.current.contains(event.target as Node)) {
        setBellOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
        toggleOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      localStorage.setItem('user_notifications', JSON.stringify(notifications));
    }
  }, [notifications]);

  useEffect(() => {
    const cleanupInterval = setInterval(() => {
      const cutoffTime = Date.now() - SEVEN_DAYS_MS;
      setNotifications(prev => prev.filter(n => n.id > cutoffTime));
    }, 60 * 60 * 1000); 

    return () => clearInterval(cleanupInterval);
  }, []);

 useEffect(() => {
    let lastEventTime = 0;

    const handleNewNotification = (event: any) => {
      const { message } = event.detail;
      
      setNotifications((prev: any) => [
        { id: Date.now(), text: message, time: new Date().toLocaleTimeString() },
        ...prev
      ]);

      setUnreadCount((prev) => prev + 1);
      setIsAnimating(true);

      const now = Date.now();
      
      if (now - lastEventTime > 500) {
        lastEventTime = now;
        
        const audio = new Audio(notifySound);
        
        audio.play().catch(error => console.error("Audio playback failed:", error));
        
        audio.addEventListener('ended', function playSecondTime() {
          audio.currentTime = 0; 
          audio.play().catch(error => console.error("Audio playback failed:", error));
          
          audio.removeEventListener('ended', playSecondTime);
        });
      }
    };

    window.addEventListener('geofence-alert', handleNewNotification);

    return () => {
      window.removeEventListener('geofence-alert', handleNewNotification);
    };
  }, []);

  const clearNotifications = () => {
    setNotifications([]); 
    setUnreadCount(0); 
    setBellOpen(false);
    setIsAnimating(false); 
    localStorage.removeItem('user_notifications');
  };

  const handleBellClick = () => {
    setBellOpen((prev) => !prev);
    setUnreadCount(0); 
    setIsAnimating(false); 
  };

  return (
    <nav className="navbar fixed-top header-navbar d-flex flex-nowrap align-items-center justify-content-between w-100 px-2">
      <div className="header-left">
        <img
          src={anytrakkLogo}
          alt="anytrakk_logo"
          className="header-logo"
          style={{ maxWidth: '120px', objectFit: 'contain' }}
        />
      </div>

      <div className="header-right d-flex align-items-center justify-content-end" style={{ gap: '10px' }}>
        
        {/* --- NEW: Added ref={bellRef} to the bell container --- */}
        <div className="dropdown" ref={bellRef}>
          <button
            className="btn position-relative p-1 d-flex align-items-center justify-content-center"
            onClick={handleBellClick}
            style={{ border: 'none', background: 'transparent', color:'#ebebeb', fontSize: '1.4rem' }}
          >
            <i className={`fas fa-bell ${isAnimating ? 'bell-animating' : ''}`}></i>
            
            {unreadCount > 0 && (
              <span 
                className="position-absolute bg-danger text-white rounded-circle" 
                style={{ 
                  top: '0px', 
                  right: '0px', 
                  fontSize: '0.65rem',
                  fontWeight: 'bold',
                  width: '18px', 
                  height: '18px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  transform: 'translate(25%, -10%)',
                  border: '1px solid #fff' 
                }}
              >
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>

          <ul 
            className={bellMenuClass} 
            style={{ 
              minWidth: '300px', 
              padding: '0',
              right: '-10px',        
              left: 'auto',          
              position: 'absolute' 
            }}
          >
            <li className="dropdown-header d-flex justify-content-between align-items-center bg-light border-bottom p-2">
              <strong style={{ color: '#333' }}>Notifications</strong>
              {notifications.length > 0 && (
                <button className="btn btn-sm btn-link text-danger p-0" onClick={clearNotifications}>
                  Clear All
                </button>
              )}
            </li>
            
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {notifications.length === 0 ? (
                <li className="p-3 text-center text-muted">No new notifications</li>
              ) : (
                notifications.map((notif: any) => (
                  <li key={notif.id} className="dropdown-item border-bottom" style={{ whiteSpace: 'normal', wordBreak: 'break-word', padding: '10px 15px' }}>
                    <div style={{ fontSize: '0.85rem', color: '#000' }}>{notif.text}</div>
                    <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                        {new Date(notif.id).toLocaleDateString()} at {notif.time}
                    </small>
                  </li>
                ))
              )}
            </div>
          </ul>
        </div>

        {/* --- NEW: Added ref={profileRef} to the profile container --- */}
        <div className="dropdown" ref={profileRef} onClick={() => toggleOpen(prev => !prev)}>
          <button
            className="btn dropdown-toggle d-flex align-items-center"
            style={{
              background: 'linear-gradient(1turn, rgb(211, 211, 211), rgb(255, 255, 255))',
              color: 'black',
              border: 'none',
              fontWeight: 'bold',
              height: '35px',
              padding: '0 10px',
              maxWidth: '175px' 
            }}
          >
            <i className="fas fa-user-circle me-1"></i>
            <span className="d-inline-block text-truncate" style={{ maxWidth: '175px', fontSize: '0.9rem' }}>
              {userName}
            </span>
          </button>

          <ul className={menuClass} style={{ right: 0, left: 'auto' }}>
            <li><a className="dropdown-item" href="#profile">Profile</a></li>
            <li><a className="dropdown-item" href="#/settings">Settings</a></li>
            <li>
              <a
                className="dropdown-item"
                href="/"
                onClick={() => {
                  localStorage.clear();
                  sessionStorage.removeItem('trips_active_tab');
                }}
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
        
      </div>
    </nav>
  );
};

export default Header;